import { Eye, Download } from 'lucide-react';
import { FauxDoc } from '@/mobile/shared/FauxDoc';
import type { Lancamento } from './types';

interface LancDocSectionProps {
  item: Pick<Lancamento, 'shot' | 'forn' | 'cnpj' | 'cat' | 'date' | 'val'>;
}

const actionBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  padding: '11px 14px',
  borderRadius: 'var(--r-3)',
  background: 'var(--card-soft)',
  border: '1px solid var(--card-stroke)',
  fontSize: 13,
  fontWeight: 600,
  color: 'var(--fg)',
  cursor: 'pointer',
  minHeight: 44,
} as const;

/**
 * Seção "Cópia da digitalização" no detalhe do lançamento.
 * Exibe a foto capturada ou FauxDoc quando não há imagem real.
 */
export function LancDocSection({ item }: LancDocSectionProps) {
  return (
    <div>
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 10,
          letterSpacing: '0.10em',
          textTransform: 'uppercase',
          fontWeight: 600,
          color: 'var(--fg-muted)',
          marginBottom: 10,
        }}
      >
        Cópia da digitalização
      </div>
      <div
        style={{
          borderRadius: 'var(--r-3)',
          overflow: 'hidden',
          border: '1px solid var(--card-stroke)',
          boxShadow: 'var(--shadow-1)',
        }}
      >
        {item.shot ? (
          <img
            src={item.shot}
            alt="Documento digitalizado"
            style={{ width: '100%', display: 'block', objectFit: 'cover' }}
          />
        ) : (
          <FauxDoc item={item} />
        )}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 10 }}>
        <button style={actionBtnStyle}>
          <Eye size={14} strokeWidth={1.7} aria-hidden />
          Ver original
        </button>
        <button style={actionBtnStyle}>
          <Download size={14} strokeWidth={1.7} aria-hidden />
          Baixar
        </button>
      </div>
    </div>
  );
}
